import { APIResponse } from '@/types/api/api';
import httpService from '../httpService';
import { SetSettingsRequest, SetSettingsResponse } from '@/types/pages/storeManagement/settings';

const getInitiator = (): string => `webpage|${window.location.href}`;

export function setSettingsAPI(storeId: number, data: SetSettingsRequest): APIResponse<SetSettingsResponse> {
    return httpService.post(`/store/${storeId}/setting`, data);
}

export interface RemoteCommandRequest {
    job_type: 'task';
    command: 'broadcast' | 'remote_command';
    payload: string;
    devices: string[];
    m2c_initiator?: string;
}

export function sendBroadcastCommandAPI(payload: Omit<RemoteCommandRequest, 'command'>): APIResponse<unknown> {
    return httpService.put('/devices/command', {
        ...payload,
        command: 'broadcast',
        m2c_initiator: getInitiator(),
    });
}

export function sendUnicastCommandAPI(payload: Omit<RemoteCommandRequest, 'command'>): APIResponse<unknown> {
    return httpService.put('/devices/command', {
        ...payload,
        command: 'remote_command',
        m2c_initiator: getInitiator(),
    });
}

export function sendRemoteCommandAPI(payload: Omit<RemoteCommandRequest, 'command'>): APIResponse<unknown> {
    return httpService.put('/devices/command', {
        ...payload,
        command: 'remote_command',
        m2c_initiator: getInitiator(),
    });
}
